import { useTranslation } from 'next-i18next';

import { type AiTutorTemplatesTranslationKeys } from '@/types/translation';

import { type TemplateAiTutor } from './types';

export const useTemplateAiTutorGetter = () => {
  const { t } = useTranslation(['aiTutorTemplates']);

  return (id: string): TemplateAiTutor => ({
    id,
    name: t(`${id}.build.name` as AiTutorTemplatesTranslationKeys),
    introduction: t(
      `${id}.build.introduction` as AiTutorTemplatesTranslationKeys,
    ),
    tags: (t(`${id}.build.tags` as AiTutorTemplatesTranslationKeys) as string)
      .split(',')
      .map(tag => tag.trim()),
    catchphrase: t(
      `${id}.build.catchphrase` as AiTutorTemplatesTranslationKeys,
    ),
    descriptions: (
      t(`${id}.build.descriptions` as AiTutorTemplatesTranslationKeys) as string
    )
      .split('\n')
      .map(line => '• ' + line.trim()),
    userExample: t(
      `${id}.build.userExample` as AiTutorTemplatesTranslationKeys,
    ),
    aiExample: t(`${id}.build.aiExample` as AiTutorTemplatesTranslationKeys),
    greeting: t(`${id}.play.greeting` as AiTutorTemplatesTranslationKeys),
    headerAvatarSrc: `/assets/ai-tutor/${id}/header.webp`,
    previewAvatarSrc: `/assets/ai-tutor/${id}/preview.webp`,
    aiAvatarSrc: `/assets/ai-tutor/${id}/AI.webp`,
    chatAvatarSrc: `/assets/ai-tutor/${id}/chat.webp`,
  });
};
